import { Text } from '@avanta/shared/components/Text';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { type Employee } from 'types/employees';
import { PatientCard } from '../PatientCard';
import { PatientCardSkeleton } from '../PatientCardSkeleton';

interface PatientSearchResultsProps {
  patients: Employee[];
  isLoading: boolean;
  onPatientSelect: (patient: Employee) => void;
}

export const PatientSearchResults = ({
  patients,
  isLoading,
  onPatientSelect,
}: PatientSearchResultsProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  if (isLoading) return <PatientCardSkeleton />;

  if (!patients.length) {
    return (
      <Text variant="text-sm-regular" className="text-denim-500">
        {t('AppointmentsReserve.SearchPatient.notFound')}
      </Text>
    );
  }

  return (
    <>
      {patients.map(patient => (
        <PatientCard key={patient.id} patient={patient} onSelect={onPatientSelect} />
      ))}
    </>
  );
};
